// extracted by mini-css-extract-plugin
export default {"section_ig":"SectionCardsGrid__section_ig--ig-JdyJh","component_ig":"SectionCardsGrid__component_ig--ig-h5q7Q","item_ig":"SectionCardsGrid__item_ig--ig-vCAwD"};